import { useContext } from 'react';
import { UnitHistoryState } from './types';
import { UnitHistoryContext } from './unit-history-context';

export function useSearchUnitHistoryResponse(): UnitHistoryState['searchUnitHistoryResponse'] {
    const context = useContext(UnitHistoryContext);
    if (!context) {
        throw new Error('Missing UnitHistoryContext');
    }
    return context.searchUnitHistoryResponse;
}

export function useSetSearchUnitHistoryResponse(): UnitHistoryState['setSearchUnitHistoryResponse'] {
    const context = useContext(UnitHistoryContext);
    if (!context) {
        throw new Error('Missing UnitHistoryContext');
    }
    return context.setSearchUnitHistoryResponse;
}

export function useSelectedUnitHistoryUnitOption(): UnitHistoryState['selectedUnitOption'] {
    const context = useContext(UnitHistoryContext);
    if (!context) {
        throw new Error('Missing UnitHistoryContext');
    }
    return context.selectedUnitOption;
}

export function useSetSelectedUnitHistoryUnitOption(): UnitHistoryState['setSelectedUnitOption'] {
    const context = useContext(UnitHistoryContext);
    if (!context) {
        throw new Error('Missing UnitHistoryContext');
    }
    return context.setSelectedUnitOption;
}
